import { API_BASE_URL } from './apiBaseUrl';

export async function uploadImage(imageFile) {
  const formData = new FormData();
  formData.append('image', imageFile);

  const response = await fetch(`${API_BASE_URL}/uploads/image`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorResult = await response.json().catch(() => ({}));
    const errorMessage = errorResult.message || 'Image upload failed';
    throw new Error(errorMessage);
  }

  const result = await response.json();

  let normalizedImageUrl = result.image_url;

  if (
    typeof normalizedImageUrl === 'string' &&
    normalizedImageUrl.startsWith('http')
  ) {
    try {
      normalizedImageUrl = new URL(normalizedImageUrl).pathname;
    } catch (error) {
      normalizedImageUrl = result.image_url;
    }
  }

  return {
    uploadedImageId: result.uploadedImageId,
    image_url: normalizedImageUrl,
  };
}
